<mat-dialog-content>
  <h1>Remove All Hours Exceptions</h1>
  <div class="close-modal" (click)="onNoClick()">X</div>
  <form [formGroup]="removeExceptionsForm">
    <mat-form-field class="date-dropdown">
      <mat-label>Date</mat-label>
      <input matInput [matDatepicker]="datepicker" formControlName="date" />
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
      <mat-datepicker #datepicker>
        <mat-datepicker-actions>
          <button mat-button matDatepickerCancel>Cancel</button>
          <button mat-raised-button matDatepickerApply>Apply</button>
        </mat-datepicker-actions>
      </mat-datepicker>
    </mat-form-field>
    <br />
    <br />
    <p class="bold">
      This will remove all scheduled hours overrides <u>for all prep locations</u> on the selected date. Do you wish to
      proceed?
    </p>
    <mat-checkbox formControlName="confirmation">Yes, remove all</mat-checkbox>

    <div class="button-container">
      <button mat-button (click)="onNoClick()" type="button">Cancel</button>

      <button
        mat-button
        mat-raised-button
        color="accent"
        [disabled]="!isIntentConfirmed()"
        (click)="startOverrideRemoval()">
        Remove All
      </button>
    </div>
  </form>
</mat-dialog-content>
